// apps/web/src/configs/EnvironmentConfig.js

const dev = {
  API_ENDPOINT_URL: 'http://localhost:3003'
}

const prod = {
  API_ENDPOINT_URL: 'https://games.nlbsolucoes.com/api'
}

const getEnv = () => {
  if (process.env.NODE_ENV === 'development') {
    return dev
  }

  return prod
}

export const env = getEnv()